import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../mockData';
import { TestimonialsColumn } from './ui/testimonials-column';

const TestimonialsGrid = () => {
  // Split 20 testimonials into 3 columns for animated scroll
  const firstColumn = testimonials.slice(0, 7);   // 7 testimonials
  const secondColumn = testimonials.slice(7, 14); // 7 testimonials
  const thirdColumn = testimonials.slice(14, 21); // 6 testimonials (son kalan)

  return (
    <section className="relative py-20 md:py-32 bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600/10 rounded-full filter blur-[120px]"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-pink-600/10 rounded-full filter blur-[120px]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div 
          className="text-center mb-12 md:mb-16 space-y-4 md:space-y-6"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 bg-purple-600/20 backdrop-blur-xl border border-purple-600/30 rounded-full px-4 md:px-6 py-2">
            <Star className="w-3 h-3 md:w-3.5 md:h-3.5 text-purple-400 fill-current" />
            <span className="text-purple-300 font-semibold text-xs md:text-sm uppercase tracking-[0.1em]">Harika Değişimler</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 tracking-tight px-4">
            Katılımcılarımızdan{' '}
            <span className="relative inline-block">
              <span className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 blur-2xl opacity-40"></span>
              <span className="relative bg-gradient-to-r from-purple-400 via-pink-400 to-purple-500 bg-clip-text text-transparent">
                Gelen
              </span>
            </span>
          </h2>
          
          <p className="text-base md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed px-4">
            Binlerce insan hayatını değiştirdi. Sıradaki siz olabilirsiniz.
          </p>
        </motion.div>

        {/* 3 Column Animated Scroll - Infinite Loop (YAVAŞ) */}
        <div className="flex justify-center gap-6 mt-10 [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)] max-h-[740px] overflow-hidden">
          <TestimonialsColumn testimonials={firstColumn} duration={40} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={45} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={42} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsGrid;
